import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Header } from '../components/layout/Header';
import WorkerTimeTracking from '../components/worker/WorkerTimeTracking';

const TimeTrackingPage = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/admin" replace />;
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-6">
        <WorkerTimeTracking />
      </main>
    </div>
  );
};

export default TimeTrackingPage;
